import { useState, useEffect } from "react";
import { MdWifiOff } from "react-icons/md";
import "./networkStatus.css";

const NetworkStatus = ({ localizedText }) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (isOnline) return null;

  return (
    <div className="network-status-banner">
      <MdWifiOff />
      {localizedText?.["you-are-offline"] ||
        "You're offline. Please check your connection."}
    </div>
  );
};

export default NetworkStatus;
